module.exports = __webpack_public_path__ + "img/banner5.4ec0c74a.png";